// extracted by mini-css-extract-plugin
export default {"checklistItem":"checklist-module--checklist-item--27534"};